import React, { useState } from "react";
import { logOut } from "../../store/auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import AccountData from "./AccountData";
import ChangePassword from "./ChangePassword";
import { setInfoMessage } from "../../store/alerts/alertsActions";
import { MdMailOutline, MdOutlineSettings } from "react-icons/md";
import "./AccountData.scss";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";
import UserDataValidator from "../UserDataValidator";
import RemoveWebUser from "./RemoveWebUser";
import EAIconButton from "../shared/Buttons/EAIconButton";
import EAButton from "../shared/Buttons/EAButton";
import EAModal from "../shared/Modal/EAModal";
import AccountDocuments from "./document";

const AccountDataPanel: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userData = useSelector((state: State) => state.auth.userData);
  const loading = useSelector((state: State) => state.auth.loading);
  const [open, setOpen] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);

  const isDesktop = useDesktopSize();
  const notAvailable = () => {
    dispatch(setInfoMessage(["Ta operacja będzie dostępna wkrótce"]));
  };

  return (
    <div className="account-data ">
      {loading ? (
        <div className="flex-between-center">
          <LoadingSpinner />
        </div>
      ) : (

        
        <div className="content-box shadow flex-between-center border">
          <h4>
            {t("czesc")}, {userData.firstName}
            {isDesktop && <React.Fragment> {userData.lastName}</React.Fragment>}
          </h4>

          <div className="buttons flex-end-center">
            {userData.allowMailing &&
          <EAIconButton
            title={t("jestes_zapisany_do_newslettera")}
            icon={<MdMailOutline/>}
            variant="icon"
            />
          }
        
           {open ? ( <EAIconButton title="" icon={<MdOutlineSettings />} onClick={() => setOpen(!open)} variant="filled" />) : ( <EAIconButton title="" icon={<MdOutlineSettings />} onClick={() => setOpen(!open)} variant="icon" />)}
          
          </div>

          {open && (
            <div className="drop-down big-shadow flex-column">
              <AccountData />
              <ChangePassword />
              <EAButton title={"Dokumenty"}  onClick={() => setOpenDoc(!openDoc)} variant="text"/>

              {userData.allowMailing && (
                <EAButton
                  title={t("zrezygnuj_z_newslettera")}
                  onClick={() => notAvailable()}
                  fullWidth
                  variant="text"
                />
              )}
              <EAButton title={t("wyloguj_sie")} onClick={() => dispatch(logOut())} fullWidth variant="text" />
              <div className="line-down"></div>
              <RemoveWebUser />
            </div>
          )}
        </div>
      )}






{/* <AccountDocuments /> */}
 <EAModal
                isOpen={openDoc}
                onClose={() => setOpenDoc(false)}
                title={"Dokumenty"}
                hideButtons
                acceptButtonLabel={t("Zamknij")}
              >
             <AccountDocuments />
              </EAModal>

      <UserDataValidator />
    </div>
  );
};

export default AccountDataPanel;
